import * as React from 'react';
/**
 *
 * Original name: Dropbox Dash
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=37649%3A10950
 *
 */
export const DropboxDashLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M13.645 5.057 7.003 6.769 9.72 9.381l6.643-1.713-2.717-2.611ZM4 12.403l13.285-3.424L20 11.59 6.715 15.014 4 12.402Zm6.334 6.54 6.643-1.712-2.715-2.612-6.643 1.713 2.715 2.611Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
